import { singleApiReducer } from './single-api-reducer';
import API from '../../API';

export const useClient = singleApiReducer(API.clients.get);
